import classNames from 'classnames';
import MaskedDisplay from 'components/ui/MaskedDisplay';

function Row({ label, value }) {
  return (
    <span className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-sm">
      <span className="text-gray-400 shrink-0">{label}:</span>
      <span className="text-gray-700">{value}</span>
    </span>
  );
}

export default function TaxProfileSummary({ profile, className }) {
  if (!profile) return null;

  return (
    <span className={classNames('block space-y-1 text-gray-600', className)}>
      {profile.taxIdNumber && (
        <Row label="Tax ID" value={<MaskedDisplay value={profile.taxIdNumber} showLastXDigits={4} />} />
      )}

      {profile.taxClassification?.title && <Row label="Classification" value={profile.taxClassification.title} />}

      {profile.w9FileName && <Row label="W-9" value={profile.w9FileName} />}
    </span>
  );
}
